import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router";
import moment from "moment-jalaali";
import VueAddtohomescreen from "@owliehq/vue-addtohomescreen";
import VueMeta from 'vue-meta';
import goTo from "vuetify/lib/services/goto";


import './registerServiceWorker'
import VuePreferences, {preference} from 'vue-preferences';
import "@/assets/styles/master.css";
import "@/assets/styles/bootstrap.min.css";
import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/brands.css";
import "@/assets/styles/light.min.css";
import "@/assets/styles/solid.min.css";
import "@/assets/styles/vuetify.css";
import "@/assets/styles/materialdesignicons.min.css";

Vue.use(VueMeta);
Vue.use(VueAddtohomescreen);

Vue.config.productionTip = false

Vue.use(VuePreferences, {
    storage: window.localStorage,
    namespace: 'masireBartar'
});

Vue.prototype.$convertDate = function (date) {
    let sliceDate = date.slice(0, 10)
    return moment(sliceDate).format('jYYYY/jMM/jDD')
}
Vue.prototype.$convertDateToMiladi = function (day) {
    return moment(day, 'jYYYY/jMM/jDD').format('YYYY-MM-DD')
}
Vue.prototype.$baseUrl = "https://pwa.masirebartarapp.com/";
//Vue.prototype.$baseUrl = "https://testpwa.masirebartarapp.com/";
//Vue.prototype.$baseUrl = "http://localhost:61106/";

Vue.prototype.$setUserData = function (userName, password, token, userID, studentID, firstName, lastName,
                                       studentPicture, studentGrade, studentClass) {
    preference('userData', {defaultValue: '{"userName":"", "password":"","token":"","userID":"","studentID":"","firstName":"","lastName":"","studentPicture":"","studentGrade":"","studentClass":""}'})
        .set(JSON.stringify({
            'userName': userName,
            'password': password,
            'token': token,
            'userID': userID,
            'studentID': studentID,
            'firstName': firstName,
            'lastName': lastName,
            'studentPicture': studentPicture,
            'studentGrade': studentGrade,
            'studentClass': studentClass,
        }));
};

Vue.prototype. $getUserData = function () {
    return JSON.parse(preference('userData',
        {defaultValue: '{"userName":"", "password":"","token":"","userID":"","studentID":"","firstName":"","lastName":"","studentPicture":"","studentGrade":"","studentClass":""}'}).get());
};
Vue.prototype.$setSchoolInfo = function (schoolName, schoolLogo, schoolID, typeDisplayScore) {
    preference('schoolInfo', {defaultValue: '{"schoolName":"","schoolLogo":"","schoolID":"", "typeDisplayScore":"typeDisplayScore"}'})
        .set(JSON.stringify({
            'schoolName': schoolName,
            'schoolLogo': schoolLogo,
            'schoolID': schoolID,
            'typeDisplayScore': typeDisplayScore
        }))
}
Vue.prototype.$getSchoolInfo = function () {
    return JSON.parse(preference('schoolInfo', {defaultValue: '{"schoolName":"","schoolLogo":"","schoolID":"", "typeDisplayScore":"typeDisplayScore"}'}).get())
}
Vue.prototype.$setUserLogo = function (studentPicture) {
    preference('userLogo', {defaultValue: '{"studentPicture":""}'})
        .set(JSON.stringify({
            'studentPicture': studentPicture,
        }));
};
Vue.prototype.$getUserLogo = function () {
    return JSON.parse(preference('userLogo',
        {defaultValue: '{"studentPicture":""}'}).get());
};

Vue.prototype.$setModalID = function (value) {
    preference('modalID', {defaultValue: ""}).set(value);
};
Vue.prototype.$getModalID = function () {
    return preference('modalID', {defaultValue: ""}).get();
};

Vue.prototype.$setExamData = function (examID, endTime) {
    let examJson = this.$getExamData()
    if (examJson === null || examJson === undefined) {
        examJson = {};
    }
    examJson[examID] = endTime

    preference('examData', {defaultValue: '{}'})
        .set(JSON.stringify(examJson));
};

Vue.prototype.$getExamData = function () {
    return JSON.parse(preference('examData',
        {defaultValue: '{}'}).get());
};

Vue.prototype.$setExamAnswers = function (examID, answers) {
    let jsonAnswers = this.$getExamAnswers()
    if (jsonAnswers === null || jsonAnswers === undefined || jsonAnswers === {}) {
        jsonAnswers = {};
    }
    jsonAnswers[examID] = answers
    preference('examAnswers', {defaultValue: '{}'})
        .set(JSON.stringify(jsonAnswers))
}

Vue.prototype.$getExamAnswers = function () {
    return JSON.parse(preference('examAnswers',
        {defaultValue: '{}'}).get());
};

Vue.prototype.$setVoteData = function (voteID, endTime) {
    let examJson = this.$getVoteData()
    if (examJson === null || examJson === undefined) {
        examJson = {};
    }
    examJson[voteID] = endTime

    preference('voteData', {defaultValue: '{}'})
        .set(JSON.stringify(examJson));
};

Vue.prototype.$getVoteData = function () {
    return JSON.parse(preference('voteData',
        {defaultValue: '{}'}).get());
};

Vue.prototype.$setVoteAnswers = function (voteID, answers) {
    let jsonAnswers = this.$getVoteAnswers()
    if (jsonAnswers === null || jsonAnswers === undefined || jsonAnswers === {}) {
        jsonAnswers = {};
    }
    jsonAnswers[voteID] = answers
    preference('voteAnswers', {defaultValue: '{}'})
        .set(JSON.stringify(jsonAnswers))
}

Vue.prototype.$getVoteAnswers = function () {
    return JSON.parse(preference('voteAnswers',
        {defaultValue: '{}'}).get());
};


Vue.prototype.$dayOfWeek = function (date) {
    return moment(date).day()
};

Vue.prototype.$replaceHttps = function (httpUrl) {
    if (httpUrl !== null) {
        return httpUrl.replace('http://', 'https://');
    }
};
Vue.prototype.$computingPriceOffer = function (price, off) {
    let priceNum = price;

    if (typeof priceNum !== "number") {
        priceNum = price.replace(",", "");
    }
    if (off === 100 || price === 0) {
        return 'رایگان'
    } else {
        return this.$numberWithCommas(parseInt(priceNum) - (parseInt(priceNum) * (off / 100))) + 'تومان';
    }
};
Vue.prototype.$numberWithCommas = function (x) {
    if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};
Vue.prototype.$openLink = function (url) {
    var newWindow = window.open("about:blank", "_blank");
    newWindow.location = url;
}
Vue.prototype.$roundNum = function (num) {
    if (num) {
        return this.$convertToQualityScore(Number(num.toFixed(1)));
    } else {
        return num
    }
}
Vue.prototype.$chooseMonth = function (monthNo, year) {

    let startDate = year;
    let endDate = year;
    if (monthNo >= 1 && monthNo <= 6) {
        startDate += '-0' + monthNo + '-01'
        endDate += '-0' + monthNo + '-31'
    } else if (monthNo >= 7 && monthNo <= 9) {
        startDate += '-0' + monthNo + '-01'
        endDate += '-0' + monthNo + '-30'
    } else if (monthNo >= 10 && monthNo <= 11) {
        startDate += '-' + monthNo + '-01'
        endDate += '-' + monthNo + '-30'
    } else if (monthNo === 12) {
        startDate += '-' + monthNo + '-01'
        endDate += '-' + monthNo + '-29'
    }
    return {startDate: startDate, endDate: endDate}
}

Vue.prototype.$convertFarsiNumber = function (number) {
    number = number.toString();
    let userNum = number.replace(/([۰-۹])/g, token => String.fromCharCode(token.charCodeAt(0) - 1728));
    return userNum
}

Vue.prototype.$convertToQualityScore = function (score) {
    if(this.$getSchoolInfo().typeDisplayScore !== 2)
    {
        return score
    }
    if (score > 80) {
        return "خیلی خوب"
    }
    if (score > 59) {
        return "خوب"
    }
    if (score > 49) {
        return "قابل قبول"
    }
    return "نیاز به تلاش بیشتر"
}
Vue.prototype.$scrollTop = function(x) {
    return goTo(x);
};

Vue.prototype.$global = {};
new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
